export default {
  title: 'Unsaved changes',
  description: 'Changes will not be saved. Do you want to proceed?',
  buttonCancel: 'Cancel',
  buttonDiscard: 'Discard',
};
